import React from 'react';
import '../styles/File.css'; // Separate CSS for this window

const File = ({ name, image, isDarkMode }) => {
    return (
        <div className="file">
            <img src={image} />
            <p className={`${isDarkMode ? 'name-dark' : 'name-light'}`}>{ name }</p>
        </div>
    );
};

export default File;
